module.exports = "<p class=\"form-global-errors\">{{ errors }}</p>"